/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
Coded by www.creative-tim.com
 =========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.
  Once you add a new route on this file it will be visible automatically on
  the Sidenav.
  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/
// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import Orders from "layouts/order";
import Exposures from "layouts/exposure";
import Transactions from "layouts/transactions";
import BatteryInfos from "layouts/battery";
import KeyMetrics from "layouts/keyMetrics";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import AgentManagements from "layouts/agent";
import Credits from "layouts/credit";
import ResetPassword from "layouts/authentication/reset-password";
import ForgetPassword from "layouts/authentication/forget-password";
import SignOut from "layouts/authentication/sign-out";
import PrivateRoute from "components/PrivateRoute";
// @mui icons
import Icon from "@mui/material/Icon";
import { Hidden } from "@mui/material";
import CouponManagement from "layouts/couponManagement";
import Products from "layouts/products";
import MembershipAnalysis from "layouts/membershipAnalysis";
import MembershipManagement from "layouts/membershipManagement";
import MarketingDataAnalysis from "layouts/marketDataAnalysis";
import Invoices from "layouts/invoice";
import Warehouses from "layouts/warehouse";
import EmployeeManagement from "layouts/employee";
import Venues from "layouts/venues";
import Manufacturer from "layouts/manufacturer";
import Tables from "layouts/tables";
import { getRolesForFeature } from "utils/roleUtils";
// import { Warehouse } from "@mui/icons-material";
const routes = [
  {
    type: "collapse",
    name: {
      zh: "總表",
      en: "Dashboard",
    },
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/tables",
    component: <PrivateRoute component={Tables} />,
    role: getRolesForFeature("tables"),
  },
  {
    type: "collapse",
    name: "Dashboard (Place Holder)",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <PrivateRoute component={Dashboard} />,
    hidden: true,
  },
  // {
  //   type: "collapse",
  //   name: {
  //     zh: "總表",
  //     en: "Dashboard",
  //   },
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <PrivateRoute component={Tables} />,
  //   role: ["BK", "SP"],
  // },
  // {
  //   type: "collapse",
  //   name: {
  //     zh: "通知",
  //     en: "Notification",
  //   },
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <PrivateRoute component={Notifications} />,
  // },
  {
    type: "collapse",
    name: "營銷數據分析",
    key: "marketingdataanalysis",
    icon: <Icon fontSize="small">trending_up</Icon>,
    route: "/marketingdataanalysis",
    component: <PrivateRoute component={MarketingDataAnalysis} />,
    role: getRolesForFeature("marketingdataanalysis"),
  },
  {
    type: "collapse",
    name: {
      zh: "產品",
      en: "Products",
    },
    key: "products",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/products",
    component: <PrivateRoute component={Products} />,
    role: getRolesForFeature("products"),
  },
  {
    type: "collapse",
    name: {
      zh: "查詢庫存/補貨",
      en: "Warehouses",
    },
    key: "warehouses",
    icon: <Icon fontSize="small">warehouse</Icon>,
    route: "/warehouses",
    component: <PrivateRoute component={Warehouses} />,
    role: getRolesForFeature("warehouses"),
  },
  {
    type: "collapse",
    name: "員工管理",
    key: "employeemanagement",
    icon: <Icon fontSize="small">engineering</Icon>,
    route: "/employeemanagement",
    component: <PrivateRoute component={EmployeeManagement} />,
    role: getRolesForFeature("employeemanagement"),
    hidden: true,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "Orders",
    icon: <Icon fontSize="small">sync_alt</Icon>,
    route: "/orders",
    component: <PrivateRoute component={Orders} />,
    hidden: true,
    role: getRolesForFeature("Orders"),
  },
  {
    type: "collapse",
    name: {
      zh: "曝險",
      en: "Exposures",
    },
    key: "Exposures",
    icon: <Icon fontSize="small">data_thresholding</Icon>,
    route: "/exposures",
    component: <PrivateRoute component={Exposures} />,
    // hidden: true,
    role: getRolesForFeature("Exposures"),
  },
  {
    type: "collapse",
    name: {
      zh: "交易",
      en: "Transactions",
    },
    key: "transactions",
    icon: <Icon fontSize="small">sync_alt</Icon>,
    route: "/transactions",
    component: <PrivateRoute component={Transactions} />,
    // hidden: true,
    role: getRolesForFeature("transactions"),
  },
  {
    type: "collapse",
    name: {
      zh: "發票",
      en: "Invoices",
    },
    key: "invoices",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/invoices",
    component: <PrivateRoute component={Invoices} />,
    // hidden: true,
    role: getRolesForFeature("invoices"),
  },
  {
    type: "collapse",
    name: {
      zh: "廠商",
      en: "Manufacturer",
    },
    key: "manufacturer",
    icon: <Icon fontSize="small">factory</Icon>,
    route: "/manufacturer",
    component: <PrivateRoute component={Manufacturer} />,
    // hidden: true,
    role: getRolesForFeature("manufacturer"),
  },
  {
    type: "collapse",
    name: {
      zh: "場域",
      en: "Venue",
    },
    key: "venues",
    icon: <Icon fontSize="small">location_city</Icon>,
    route: "/venues",
    component: <PrivateRoute component={Venues} />,
    // hidden: true,
    role: getRolesForFeature("venues"),
  },
  {
    type: "collapse",
    name: {
      zh: "裝置資訊",
      en: "Device Infos",
    },
    key: "deviceinfos",
    icon: <Icon fontSize="small">speed</Icon>,
    route: "/deviceinfos",
    component: <PrivateRoute component={BatteryInfos} />,
    // hidden: true,
    role: getRolesForFeature("deviceinfos"),
  },
  {
    type: "collapse",
    name: {
      zh: "信用額度",
      en: "Credits",
    },
    key: "Credits",
    icon: <Icon fontSize="small">monetization_on</Icon>,
    route: "/credits",
    component: <PrivateRoute component={Credits} />,
    // hidden: true,
    role: getRolesForFeature("Credits"),
  },
  {
    type: "collapse",
    name: {
      zh: "管理從屬與層級",
      en: "Agent Managements",
    },
    key: "agentmanagements",
    icon: <Icon fontSize="small">account_tree</Icon>,
    route: "/agentmanagements",
    component: <PrivateRoute component={AgentManagements} />,
    role: getRolesForFeature("agentmanagements"),
  },
  {
    type: "collapse",
    name: "會員管理",
    key: "membershipmanagement",
    icon: <Icon fontSize="small">manage_accounts</Icon>,
    route: "/membershipmanagement",
    component: <PrivateRoute component={MembershipManagement} />,
    role: getRolesForFeature("membershipmanagement"),
  },
  {
    type: "collapse",
    name: "優惠券管理",
    key: "couponmanagement",
    icon: <Icon fontSize="small">discount</Icon>,
    route: "/couponmanagement",
    component: <PrivateRoute component={CouponManagement} />,
    role: getRolesForFeature("couponmanagement"),
  },
  {
    type: "collapse",
    name: "關鍵指標數據(beta)",
    key: "keymetrics",
    icon: <Icon fontSize="small">bar_chart</Icon>,
    route: "/keymetrics",
    component: <PrivateRoute component={KeyMetrics} />,
    hidden: true,
    role: getRolesForFeature("keymetrics"),
  },
  {
    type: "collapse",
    name: "會員數據分析(beta)",
    key: "membershipanalysis",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/membershipanalysis",
    component: <PrivateRoute component={MembershipAnalysis} />,
    hidden: true,
    role: getRolesForFeature("membershipanalysis"),
  },

  // {}
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <PrivateRoute component={Billing} />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <PrivateRoute component={RTL} />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <PrivateRoute component={Profile} />,
  // },
  {
    type: "collapse",
    name: {
      zh: "登入",
      en: "Sign In",
    },
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    hidden: true,
    component: <SignIn />,
    role: getRolesForFeature("sign-in"),
  },
  // {
  //   type: "collapse",
  //   name: "Forget Password Reset",
  //   key: "reset-password",
  //   icon: <Icon fontSize="small">login</Icon>,
  //   route: "/authentication/reset-pass",
  //   component: <SignIn />,
  // },
  {
    type: "collapse",
    name: {
      zh: "更改密碼",
      en: "Reset Password",
    },
    key: "reset-password",
    icon: <Icon fontSize="small">lock_reset</Icon>,
    route: "/authentication/reset-password",
    component: <ResetPassword />,
    role: getRolesForFeature("reset-password"),
  },
  {
    type: "collapse",
    name: {
      zh: "忘記密碼",
      en: "Forget Password",
    },
    key: "forget-password",
    icon: <Icon fontSize="small">lock_reset</Icon>,
    route: "/authentication/forget-password",
    component: <ForgetPassword />,
    hidden: true,
    role: getRolesForFeature("forget-password"),
  },
  {
    type: "collapse",
    name: {
      zh: "登出",
      en: "Sign Out",
    },
    key: "sign-out",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/authentication/sign-out",
    component: <SignOut />, // 引入 SignOut 組件
    role: getRolesForFeature("sign-out"),
  },
];
export default routes;
